import PortalDialogType from "./PortalDialogType";
import FieldGroup from "./field/FieldGroup";
import PortalFields from "./field/PortalFields";
import MimeTypeFilter from "../document/mimetype/MimeTypeFilter";
import MimeTypes from "../document/mimetype/MimeTypes";
import RotateDialogFields from "./field/page/RotateDialogFields";
import ConvertDialogFields from "./field/convert/ConvertDialogFields";
import RenameDialogFields from "./field/document/RenameDialogFields";
import PrintDialogFields from "./field/document/PrintDialogFields";
import DeletePageDialogFields from "./field/page/DeletePageDialogFields";
import SplitDialogFields from "./field/page/SplitDialogFields";
import WatermarkDialogFields from "./field/page/WatermarkDialogFields";
import GlobalAttachmentDialogFields from "./field/attachment/GlobalAttachmentDialogFields";
import ContentExtractionDialogFields from "./field/export/ContentExtractionDialogFields";
import ImageExtractionDialogFields from "./field/export/ImageExtractionDialogFields";
import InfoExtractionDialogFields from "./field/export/InfoExtractionDialogFields";
import PageExtractionDialogFields from "./field/export/PageExtractionDialogFields";
import BackgroundDialogFields from "./field/page/BackgroundDialogFields";
import HeaderFooterDialogFields from "./field/page/HeaderFooterDialogFields";
import DescriptionDialogFields from "./field/document/DescriptionDialogFields";
import ViewDialogFields from "./field/document/ViewDialogFields";
import BoxesDialogFields from "./field/page/BoxesDialogFields";
import TransitionDialogFields from "./field/page/TransitionDialogFields";
import PageAddDialogFields from "./field/page/PageAddDialogFields";
import PdfaDialogFields from "./field/convert/PdfaDialogFields";
import OcrDialogFields from "./field/convert/OcrDialogFields";
import SignatureDialogFields from "./field/signature/SignatureDialogFields";
import FormsExtractionDialogFields from "./field/forms/FormsExtractionDialogFields";
import FormsImportDialogFields from "./field/forms/FormsImportDialogFields";
import SanitizeDialogFields from "./field/document/SanitizeDialogFields";
import RedactDialogFields from "./field/redact/RedactDialogFields";
import OutlineAddFields from "./field/document/OutlineAddFields";
import BarcodeFields from "./field/barcode/BarcodeFields";
import BarcodeDetectDialogFields from "./field/barcode/BarcodeDetectDialogFields";
import AttachmentDialogFields from "./field/attachment/AttachmentDialogFields";
import AnnotationNoteDialogFields from "./field/annotation/AnnotationNoteDialogFields";
import AnnotationMarkDialogFields from "./field/annotation/AnnotationMarkDialogFields";
import AnnotationUnderlineDialogFields from "./field/annotation/AnnotationUnderlineDialogFields";
import AnnotationStrikeDialogFields from "./field/annotation/AnnotationStrikeDialogFields";
import FileTypeGroupFilter from "../document/mimetype/FileTypeGroupFilter";
import FileTypeGroup from "../document/mimetype/FileTypeGroup";
import MergeDialogFields from "./field/document/MergeDialogFields";
import PortfolioCreateDialogFields from "./field/portfolio/PortfolioCreateDialogFields";
import EncryptDialogFields from "./field/security/EncryptDialogFields";
import UrlConverterDialogFields from "./field/document/UrlConverterDialogFields";
import CertificateEncryptDialogFields from "./field/security/CertificateEncryptDialogFields";
import BarcodeSwissQrCodeFormDialogFields from "./field/barcode/BarcodeSwissQrCodeFormDialogFields";
import CompressionDialogFields from "./field/document/CompressionDialogFields";
import ScaleDialogFields from "./field/page/ScaleDialogFields";
import HtmlExtractionDialogFields from "./field/export/HtmlExtractionDialogFields";
import OrientationDialogFields from "./field/page/OrientationDialogFields";
import DeleteAnnotationDialogFields from "./field/annotation/DeleteAnnotationDialogFields";
import AnnotationSquigglyDialogFields from "./field/annotation/AnnotationSquigglyDialogFields";
import AnnotationLineFunctionFields from "./field/annotation/AnnotationLineFunctionFields";
import AnnotationSquareFunctionFields from "./field/annotation/AnnotationSquareFunctionFields";
import AnnotationCircleFunctionFields from "./field/annotation/AnnotationCircleFunctionFields";
import AnnotationReplyDialogFields from "./field/annotation/AnnotationReplyDialogFields";
import AnnotationStampFunctionFields from "./field/annotation/AnnotationStampFunctionFields";
import AnnotationFlattenDialogFields from "./field/annotation/AnnotationFlattenDialogFields";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import SignatureRemoveDialogFields from "./field/signature/SignatureRemoveDialogFields";

class PortalDialogFields {
	private static _instance: PortalDialogFields;
	private _fields: Map<PortalDialogType, FieldGroup>;

	private constructor() {
		this._fields = new Map<PortalDialogType, FieldGroup>([
			[
				PortalDialogType.ROTATE,
				new FieldGroup([
					new PortalFields([
							RotateDialogFields.PAGERANGE,
							RotateDialogFields.PAGES,
							RotateDialogFields.DIRECTION,
							RotateDialogFields.ROTATION,
							RotateDialogFields.ORIENTATION
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ORIENTATION,
				new FieldGroup([
					new PortalFields([
							OrientationDialogFields.DIRECTION,
							OrientationDialogFields.ORIENTATION
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.CONVERT,
				new FieldGroup([
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.PAGERANGE,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.UNIT,
							ConvertDialogFields.ASPECT_RATIO
						],
						new MimeTypeFilter([], [MimeTypes.ALL]),
						new FileTypeGroupFilter([], [FileTypeGroup.IMAGE])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.PAGERANGE,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.UNIT,
							ConvertDialogFields.ASPECT_RATIO
						],
						new MimeTypeFilter([], [
							MimeTypes.HEIF, MimeTypes.HEIC, MimeTypes.HEIF_SEQUENCE, MimeTypes.HEIC_SEQUENCE,
							MimeTypes.TIFF
						])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.EMBED_FONTS,
							ConvertDialogFields.PAGERANGE,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.PASSWORD,
							ConvertDialogFields.UNIT
						],
						new MimeTypeFilter([], [MimeTypes.ALL]),
						new FileTypeGroupFilter([], [FileTypeGroup.OFFICE, FileTypeGroup.WORD])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.EMBED_FONTS,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.EMAIL_ATTACHMENT,
							ConvertDialogFields.EMAIL_ADJUST_FONTS,
							ConvertDialogFields.EMAIL_DOWNLOAD_IMAGES,
							ConvertDialogFields.EMAIL_USE_BACKGROUND,
							ConvertDialogFields.EMAIL_RESIZE_IMAGES,
							ConvertDialogFields.EMAIL_RESIZE_TABLES,
							ConvertDialogFields.TEMPLATE_LANGUAGE,
							ConvertDialogFields.UNIT,
							ConvertDialogFields.HEADER_PLAIN,
							ConvertDialogFields.HEADER_FONT_FAMILY,
							ConvertDialogFields.HEADER_FONT_SIZE,
							ConvertDialogFields.HEADER_FONT_COLOR,
							ConvertDialogFields.HEADER_ALIGNMENT,
							ConvertDialogFields.HEADER_CONTENT,
							ConvertDialogFields.HEADER_MARGIN_LEFT,
							ConvertDialogFields.HEADER_MARGIN_RIGHT,
							ConvertDialogFields.HEADER_MARGIN_TOP,
							ConvertDialogFields.HEADER_MARGIN_BOTTOM,
							ConvertDialogFields.FOOTER_PLAIN,
							ConvertDialogFields.FOOTER_FONT_FAMILY,
							ConvertDialogFields.FOOTER_FONT_SIZE,
							ConvertDialogFields.FOOTER_FONT_COLOR,
							ConvertDialogFields.FOOTER_ALIGNMENT,
							ConvertDialogFields.FOOTER_CONTENT,
							ConvertDialogFields.FOOTER_MARGIN_LEFT,
							ConvertDialogFields.FOOTER_MARGIN_RIGHT,
							ConvertDialogFields.FOOTER_MARGIN_TOP,
							ConvertDialogFields.FOOTER_MARGIN_BOTTOM,
							ConvertDialogFields.ASPECT_RATIO
						],
						new MimeTypeFilter([], [MimeTypes.ALL]),
						new FileTypeGroupFilter([], [FileTypeGroup.MAIL])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.EMBED_FONTS,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.HTML_PARSED,
							ConvertDialogFields.HTML_USE_AS_TEMPLATE,
							ConvertDialogFields.HTML_TEMPLATE_FILE,
							ConvertDialogFields.HTML_TEMPLATE_USE_FILE,
							ConvertDialogFields.HTML_TEMPLATE_CONTENT,
							ConvertDialogFields.BASE_URL,
							ConvertDialogFields.HTML_USE_BACKGROUND,
							ConvertDialogFields.HTML_DOWNLOAD_IMAGES,
							ConvertDialogFields.HTML_ADJUST_FONTS,
							ConvertDialogFields.SYNTAX_DETECTION,
							ConvertDialogFields.LANGUAGE,
							ConvertDialogFields.FONT_FAMILY,
							ConvertDialogFields.WORD_BREAK,
							ConvertDialogFields.LINE_HEIGHT,
							ConvertDialogFields.FONT_SIZE,
							ConvertDialogFields.LINE_NUMBERS,
							ConvertDialogFields.FONT_COLOR,
							ConvertDialogFields.UNIT,
							ConvertDialogFields.HEADER_PLAIN,
							ConvertDialogFields.HEADER_FONT_FAMILY,
							ConvertDialogFields.HEADER_FONT_SIZE,
							ConvertDialogFields.HEADER_FONT_COLOR,
							ConvertDialogFields.HEADER_ALIGNMENT,
							ConvertDialogFields.HEADER_CONTENT,
							ConvertDialogFields.HEADER_MARGIN_LEFT,
							ConvertDialogFields.HEADER_MARGIN_RIGHT,
							ConvertDialogFields.HEADER_MARGIN_TOP,
							ConvertDialogFields.HEADER_MARGIN_BOTTOM,
							ConvertDialogFields.FOOTER_PLAIN,
							ConvertDialogFields.FOOTER_FONT_FAMILY,
							ConvertDialogFields.FOOTER_FONT_SIZE,
							ConvertDialogFields.FOOTER_FONT_COLOR,
							ConvertDialogFields.FOOTER_ALIGNMENT,
							ConvertDialogFields.FOOTER_CONTENT,
							ConvertDialogFields.FOOTER_MARGIN_LEFT,
							ConvertDialogFields.FOOTER_MARGIN_RIGHT,
							ConvertDialogFields.FOOTER_MARGIN_TOP,
							ConvertDialogFields.FOOTER_MARGIN_BOTTOM,
							ConvertDialogFields.HTML_ERROR_REPORT,
							ConvertDialogFields.HTML_ERROR_REPORT_FORMAT
						],
						new MimeTypeFilter([], [MimeTypes.HTML])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.EMBED_FONTS,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.SYNTAX_DETECTION,
							ConvertDialogFields.LANGUAGE,
							ConvertDialogFields.FONT_FAMILY,
							ConvertDialogFields.WORD_BREAK,
							ConvertDialogFields.LINE_HEIGHT,
							ConvertDialogFields.FONT_SIZE,
							ConvertDialogFields.LINE_NUMBERS,
							ConvertDialogFields.FONT_COLOR,
							ConvertDialogFields.XML_MODE,
							ConvertDialogFields.XSLT_FILE,
							ConvertDialogFields.XRECHNUNG_OVERWRITE,
							ConvertDialogFields.XRECHNUNG_FILE,
							ConvertDialogFields.UNIT,
							ConvertDialogFields.HEADER_PLAIN,
							ConvertDialogFields.HEADER_FONT_FAMILY,
							ConvertDialogFields.HEADER_FONT_SIZE,
							ConvertDialogFields.HEADER_FONT_COLOR,
							ConvertDialogFields.HEADER_ALIGNMENT,
							ConvertDialogFields.HEADER_CONTENT,
							ConvertDialogFields.HEADER_MARGIN_LEFT,
							ConvertDialogFields.HEADER_MARGIN_RIGHT,
							ConvertDialogFields.HEADER_MARGIN_TOP,
							ConvertDialogFields.HEADER_MARGIN_BOTTOM,
							ConvertDialogFields.FOOTER_PLAIN,
							ConvertDialogFields.FOOTER_FONT_FAMILY,
							ConvertDialogFields.FOOTER_FONT_SIZE,
							ConvertDialogFields.FOOTER_FONT_COLOR,
							ConvertDialogFields.FOOTER_ALIGNMENT,
							ConvertDialogFields.FOOTER_CONTENT,
							ConvertDialogFields.FOOTER_MARGIN_LEFT,
							ConvertDialogFields.FOOTER_MARGIN_RIGHT,
							ConvertDialogFields.FOOTER_MARGIN_TOP,
							ConvertDialogFields.FOOTER_MARGIN_BOTTOM,
						],
						new MimeTypeFilter([], [MimeTypes.XML, MimeTypes.APPXML, MimeTypes.APPXSLTXML])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.EMBED_FONTS,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.SYNTAX_DETECTION,
							ConvertDialogFields.LANGUAGE,
							ConvertDialogFields.FONT_FAMILY,
							ConvertDialogFields.WORD_BREAK,
							ConvertDialogFields.LINE_HEIGHT,
							ConvertDialogFields.FONT_SIZE,
							ConvertDialogFields.LINE_NUMBERS,
							ConvertDialogFields.FONT_COLOR,
							ConvertDialogFields.UNIT,
							ConvertDialogFields.HEADER_PLAIN,
							ConvertDialogFields.HEADER_FONT_FAMILY,
							ConvertDialogFields.HEADER_FONT_SIZE,
							ConvertDialogFields.HEADER_FONT_COLOR,
							ConvertDialogFields.HEADER_ALIGNMENT,
							ConvertDialogFields.HEADER_CONTENT,
							ConvertDialogFields.HEADER_MARGIN_LEFT,
							ConvertDialogFields.HEADER_MARGIN_RIGHT,
							ConvertDialogFields.HEADER_MARGIN_TOP,
							ConvertDialogFields.HEADER_MARGIN_BOTTOM,
							ConvertDialogFields.FOOTER_PLAIN,
							ConvertDialogFields.FOOTER_FONT_FAMILY,
							ConvertDialogFields.FOOTER_FONT_SIZE,
							ConvertDialogFields.FOOTER_FONT_COLOR,
							ConvertDialogFields.FOOTER_ALIGNMENT,
							ConvertDialogFields.FOOTER_CONTENT,
							ConvertDialogFields.FOOTER_MARGIN_LEFT,
							ConvertDialogFields.FOOTER_MARGIN_RIGHT,
							ConvertDialogFields.FOOTER_MARGIN_TOP,
							ConvertDialogFields.FOOTER_MARGIN_BOTTOM,
						],
						new MimeTypeFilter([], [MimeTypes.ALL]),
						new FileTypeGroupFilter([], [FileTypeGroup.TEXT])
					),
					new PortalFields([
							ConvertDialogFields.PDFA_FORMAT,
							ConvertDialogFields.PDFA_RESOLUTION,
							ConvertDialogFields.JPEG_QUALITY,
							ConvertDialogFields.EMBED_FONTS,
							ConvertDialogFields.PAGE_FORMAT,
							ConvertDialogFields.ORIENTATION,
							ConvertDialogFields.WIDTH,
							ConvertDialogFields.HEIGHT,
							ConvertDialogFields.MARGIN_TOP,
							ConvertDialogFields.MARGIN_BOTTOM,
							ConvertDialogFields.MARGIN_LEFT,
							ConvertDialogFields.MARGIN_RIGHT,
							ConvertDialogFields.PREVIEW,
							ConvertDialogFields.RESOLUTION,
							ConvertDialogFields.DPI,
							ConvertDialogFields.UNIT
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.RENAME,
				new FieldGroup([
					new PortalFields([
							RenameDialogFields.FILENAME
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.PRINT,
				new FieldGroup([
					new PortalFields([
							PrintDialogFields.PRINTER,
							PrintDialogFields.COPIES,
							PrintDialogFields.EXPAND,
							PrintDialogFields.SHRINK,
							PrintDialogFields.AUTO_ROTATE,
							PrintDialogFields.CENTER,
							PrintDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.DELETE_PAGE,
				new FieldGroup([
					new PortalFields([
							DeletePageDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SPLIT,
				new FieldGroup([
					new PortalFields([
							SplitDialogFields.MODE,
							SplitDialogFields.MODE_FIRST,
							SplitDialogFields.MODE_LAST,
							SplitDialogFields.MODE_LIST,
							SplitDialogFields.PAGENUMBER,
							SplitDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.WATERMARK,
				new FieldGroup([
					new PortalFields([
							WatermarkDialogFields.MODE,
							WatermarkDialogFields.CONTENT,
							WatermarkDialogFields.FONT_FAMILY,
							WatermarkDialogFields.FONT_SIZE,
							WatermarkDialogFields.FONT_COLOR,
							WatermarkDialogFields.FONT_OPACITY,
							WatermarkDialogFields.IMAGE_FILE,
							WatermarkDialogFields.IMAGE_OPACITY,
							WatermarkDialogFields.IMAGE_SCALE,
							WatermarkDialogFields.POSITION,
							WatermarkDialogFields.MARGIN_LEFT,
							WatermarkDialogFields.MARGIN_TOP,
							WatermarkDialogFields.ASPECT_RATIO,
							WatermarkDialogFields.ROTATION,
							WatermarkDialogFields.PAGERANGE,
							WatermarkDialogFields.PREVIEW
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ATTACHMENT_ADD_GLOBAL,
				new FieldGroup([
					new PortalFields([
							GlobalAttachmentDialogFields.FILE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ATTACHMENT_ADD,
				new FieldGroup([
					new PortalFields([
							AttachmentDialogFields.FILE,
							AttachmentDialogFields.TEXT,
							AttachmentDialogFields.LOCKED,
							AttachmentDialogFields.ICON,
							AttachmentDialogFields.COLOR,
							AttachmentDialogFields.OPACITY
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_CONTENT,
				new FieldGroup([
					new PortalFields([
							ContentExtractionDialogFields.MODE,
							ContentExtractionDialogFields.DELIMIT_AFTER_PUNCTUATION,
							ContentExtractionDialogFields.REMOVE_PUNCTUATION,
							ContentExtractionDialogFields.EXTENDED_SEQUENCE_CHARACTERS,
							ContentExtractionDialogFields.FALLBACK_FORMAT,
							ContentExtractionDialogFields.FILE_FORMAT,
							ContentExtractionDialogFields.FROM_TEXT,
							ContentExtractionDialogFields.PAGERANGE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_IMAGES,
				new FieldGroup([
					new PortalFields([
							ImageExtractionDialogFields.FORMAT,
							ImageExtractionDialogFields.DPI,
							ImageExtractionDialogFields.HEIGHT,
							ImageExtractionDialogFields.WIDTH,
							ImageExtractionDialogFields.JPEG_QUALITY,
							ImageExtractionDialogFields.METRICS,
							ImageExtractionDialogFields.COMPRESSION,
							ImageExtractionDialogFields.MULTIPAGE,
							ImageExtractionDialogFields.PAGERANGE,
							ImageExtractionDialogFields.SVG_STATE_MODE,
							ImageExtractionDialogFields.SVG_PATH_DRAW_MODE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_INFO,
				new FieldGroup([
					new PortalFields([
							InfoExtractionDialogFields.FILE_FORMAT
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_PAGE,
				new FieldGroup([
					new PortalFields([
							PageExtractionDialogFields.TYPE,
							PageExtractionDialogFields.TYPE_SELECTED,
							PageExtractionDialogFields.TYPE_VARIABLE,
							PageExtractionDialogFields.TYPE_GROUP,
							PageExtractionDialogFields.TYPE_SEPARATE,
							PageExtractionDialogFields.DELETE,
							PageExtractionDialogFields.FROM,
							PageExtractionDialogFields.COUNT,
							PageExtractionDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BACKGROUND,
				new FieldGroup([
					new PortalFields([
							BackgroundDialogFields.MODE,
							BackgroundDialogFields.TYPE,
							BackgroundDialogFields.COLOR,
							BackgroundDialogFields.OPACITY,
							BackgroundDialogFields.RELATIVE,
							BackgroundDialogFields.SCALE,
							BackgroundDialogFields.POSITION,
							BackgroundDialogFields.MARGIN_LEFT,
							BackgroundDialogFields.MARGIN_TOP,
							BackgroundDialogFields.ROTATION,
							BackgroundDialogFields.IMAGE,
							BackgroundDialogFields.VISIBILITY_PRINT,
							BackgroundDialogFields.VISIBILITY_SCREEN,
							BackgroundDialogFields.PAGE_MODE,
							BackgroundDialogFields.PAGE_FROM,
							BackgroundDialogFields.PAGE_TO,
							BackgroundDialogFields.PREVIEW
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.HEADER_FOOTER,
				new FieldGroup([
					new PortalFields([
							HeaderFooterDialogFields.MODE,
							HeaderFooterDialogFields.FONT_FAMILY,
							HeaderFooterDialogFields.FONT_SIZE,
							HeaderFooterDialogFields.FONT_COLOR,
							HeaderFooterDialogFields.UNDERLINE,
							HeaderFooterDialogFields.MARGIN_LEFT,
							HeaderFooterDialogFields.MARGIN_RIGHT,
							HeaderFooterDialogFields.MARGIN_TOP,
							HeaderFooterDialogFields.MARGIN_BOTTOM,
							HeaderFooterDialogFields.PAGES_FROM,
							HeaderFooterDialogFields.PAGES_TO,
							HeaderFooterDialogFields.PAGES_FIRST,
							HeaderFooterDialogFields.PAGES_FILTER,
							HeaderFooterDialogFields.HEADER_LEFT,
							HeaderFooterDialogFields.HEADER_LEFT_TYPE,
							HeaderFooterDialogFields.HEADER_LEFT_DATE,
							HeaderFooterDialogFields.HEADER_LEFT_PAGES,
							HeaderFooterDialogFields.HEADER_LEFT_CUSTOM,
							HeaderFooterDialogFields.HEADER_LEFT_BATES_PREFIX,
							HeaderFooterDialogFields.HEADER_LEFT_BATES_SUFFIX,
							HeaderFooterDialogFields.HEADER_LEFT_BATES_DIGITS,
							HeaderFooterDialogFields.HEADER_CENTER,
							HeaderFooterDialogFields.HEADER_CENTER_TYPE,
							HeaderFooterDialogFields.HEADER_CENTER_DATE,
							HeaderFooterDialogFields.HEADER_CENTER_PAGES,
							HeaderFooterDialogFields.HEADER_CENTER_CUSTOM,
							HeaderFooterDialogFields.HEADER_CENTER_BATES_PREFIX,
							HeaderFooterDialogFields.HEADER_CENTER_BATES_SUFFIX,
							HeaderFooterDialogFields.HEADER_CENTER_BATES_DIGITS,
							HeaderFooterDialogFields.HEADER_RIGHT,
							HeaderFooterDialogFields.HEADER_RIGHT_TYPE,
							HeaderFooterDialogFields.HEADER_RIGHT_DATE,
							HeaderFooterDialogFields.HEADER_RIGHT_PAGES,
							HeaderFooterDialogFields.HEADER_RIGHT_CUSTOM,
							HeaderFooterDialogFields.HEADER_RIGHT_BATES_PREFIX,
							HeaderFooterDialogFields.HEADER_RIGHT_BATES_SUFFIX,
							HeaderFooterDialogFields.HEADER_RIGHT_BATES_DIGITS,
							HeaderFooterDialogFields.FOOTER_LEFT,
							HeaderFooterDialogFields.FOOTER_LEFT_TYPE,
							HeaderFooterDialogFields.FOOTER_LEFT_DATE,
							HeaderFooterDialogFields.FOOTER_LEFT_PAGES,
							HeaderFooterDialogFields.FOOTER_LEFT_CUSTOM,
							HeaderFooterDialogFields.FOOTER_LEFT_BATES_PREFIX,
							HeaderFooterDialogFields.FOOTER_LEFT_BATES_SUFFIX,
							HeaderFooterDialogFields.FOOTER_LEFT_BATES_DIGITS,
							HeaderFooterDialogFields.FOOTER_CENTER,
							HeaderFooterDialogFields.FOOTER_CENTER_TYPE,
							HeaderFooterDialogFields.FOOTER_CENTER_DATE,
							HeaderFooterDialogFields.FOOTER_CENTER_PAGES,
							HeaderFooterDialogFields.FOOTER_CENTER_CUSTOM,
							HeaderFooterDialogFields.FOOTER_CENTER_BATES_PREFIX,
							HeaderFooterDialogFields.FOOTER_CENTER_BATES_SUFFIX,
							HeaderFooterDialogFields.FOOTER_CENTER_BATES_DIGITS,
							HeaderFooterDialogFields.FOOTER_RIGHT,
							HeaderFooterDialogFields.FOOTER_RIGHT_TYPE,
							HeaderFooterDialogFields.FOOTER_RIGHT_DATE,
							HeaderFooterDialogFields.FOOTER_RIGHT_PAGES,
							HeaderFooterDialogFields.FOOTER_RIGHT_CUSTOM,
							HeaderFooterDialogFields.FOOTER_RIGHT_BATES_PREFIX,
							HeaderFooterDialogFields.FOOTER_RIGHT_BATES_SUFFIX,
							HeaderFooterDialogFields.FOOTER_RIGHT_BATES_DIGITS
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.DESCRIPTION,
				new FieldGroup([
					new PortalFields([
							DescriptionDialogFields.TITLE,
							DescriptionDialogFields.AUTHOR,
							DescriptionDialogFields.SUBJECT,
							DescriptionDialogFields.KEYWORDS,
							DescriptionDialogFields.PRODUCER,
							DescriptionDialogFields.CREATOR,
							DescriptionDialogFields.CUSTOM,
							DescriptionDialogFields.KEY,
							DescriptionDialogFields.VALUE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.VIEW,
				new FieldGroup([
					new PortalFields([
							ViewDialogFields.PAGE_MODE,
							ViewDialogFields.ZOOM_MODE,
							ViewDialogFields.ZOOM,
							ViewDialogFields.OPEN_MODE,
							ViewDialogFields.START_PAGE,
							ViewDialogFields.FIT_WINDOW,
							ViewDialogFields.CENTER_WINDOW,
							ViewDialogFields.TITLE,
							ViewDialogFields.HIDE_TOOLBAR,
							ViewDialogFields.HIDE_MENUBAR,
							ViewDialogFields.HIDE_WINDOW_UI,
							ViewDialogFields.TEXT_DIRECTION,
							ViewDialogFields.PRINT_SCALE,
							ViewDialogFields.PRINT_COPIES,
							ViewDialogFields.PRINT_PAGERANGE,
							ViewDialogFields.PRINT_TRAY,
							ViewDialogFields.PRINT_DUPLEX,
							ViewDialogFields.VIEW_AREA,
							ViewDialogFields.VIEW_CLIP,
							ViewDialogFields.PRINT_AREA,
							ViewDialogFields.PRINT_CLIP
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BOXES,
				new FieldGroup([
					new PortalFields([
							BoxesDialogFields.MODE,
							BoxesDialogFields.TYPE,
							BoxesDialogFields.WIDTH,
							BoxesDialogFields.HEIGHT,
							BoxesDialogFields.MARGIN_LEFT,
							BoxesDialogFields.MARGIN_TOP,
							BoxesDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.TRANSITION,
				new FieldGroup([
					new PortalFields([
							TransitionDialogFields.MODE,
							TransitionDialogFields.STYLE,
							TransitionDialogFields.DIRECTION,
							TransitionDialogFields.DURATION,
							TransitionDialogFields.AUTO_SCROLL,
							TransitionDialogFields.SCROLL_TIME,
							TransitionDialogFields.FLY_OPAQUE,
							TransitionDialogFields.FLY_SCALE,
							TransitionDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ADD_PAGE,
				new FieldGroup([
					new PortalFields([
							PageAddDialogFields.OPERATION,
							PageAddDialogFields.DOCUMENT,
							PageAddDialogFields.PAGE,
							PageAddDialogFields.RESET
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.PDFA,
				new FieldGroup([
					new PortalFields([
							PdfaDialogFields.FORMAT,
							PdfaDialogFields.RESOLUTION,
							PdfaDialogFields.ERROR_CORRECTION,
							PdfaDialogFields.FILE,
							PdfaDialogFields.VERSION,
							PdfaDialogFields.ZUGFERD,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.OCR,
				new FieldGroup([
					new PortalFields([
							OcrDialogFields.OUTPUT_FORMAT,
							OcrDialogFields.LANGUAGE,
							OcrDialogFields.NORMALIZE_ROTATION,
							OcrDialogFields.FAIL_ON_WARNING,
							OcrDialogFields.JPEG_QUALITY,
							OcrDialogFields.DPI,
							OcrDialogFields.PDFA_FORMAT,
							OcrDialogFields.PDFA_RESOLUTION,
							OcrDialogFields.OPTIMIZE,
							OcrDialogFields.DESKEW,
							OcrDialogFields.DESPECKLE,
							OcrDialogFields.DITHERING,
							OcrDialogFields.NOISE_REDUCTION,
							OcrDialogFields.GAMMA_CORRECTION,
							OcrDialogFields.INCREASE_CONTRAST,
							OcrDialogFields.EDGE_ACCENTUATION,
							OcrDialogFields.SHARPEN,
							OcrDialogFields.MEDIAN_FILTER
						],
						new MimeTypeFilter([], [MimeTypes.PDF])
					),
					new PortalFields([
							OcrDialogFields.OUTPUT_FORMAT,
							OcrDialogFields.LANGUAGE,
							OcrDialogFields.CHECK_RESOLUTION,
							OcrDialogFields.FAIL_ON_WARNING,
							OcrDialogFields.JPEG_QUALITY,
							OcrDialogFields.DPI,
							OcrDialogFields.PDFA_FORMAT,
							OcrDialogFields.PDFA_RESOLUTION,
							OcrDialogFields.OPTIMIZE,
							OcrDialogFields.DESKEW,
							OcrDialogFields.DESPECKLE,
							OcrDialogFields.DITHERING,
							OcrDialogFields.NOISE_REDUCTION,
							OcrDialogFields.GAMMA_CORRECTION,
							OcrDialogFields.INCREASE_CONTRAST,
							OcrDialogFields.EDGE_ACCENTUATION,
							OcrDialogFields.SHARPEN,
							OcrDialogFields.MEDIAN_FILTER,
							OcrDialogFields.PAGE_FORMAT,
							OcrDialogFields.SIZE,
							OcrDialogFields.WIDTH,
							OcrDialogFields.HEIGHT,
							OcrDialogFields.ORIENTATION,
							OcrDialogFields.PREVIEW
						],
						new MimeTypeFilter([], [MimeTypes.PNG, MimeTypes.JPEG, MimeTypes.TIFF])
					),
					new PortalFields([
							OcrDialogFields.OUTPUT_FORMAT,
							OcrDialogFields.LANGUAGE,
							OcrDialogFields.FAIL_ON_WARNING,
							OcrDialogFields.JPEG_QUALITY,
							OcrDialogFields.DPI,
							OcrDialogFields.PDFA_FORMAT,
							OcrDialogFields.PDFA_RESOLUTION,
							OcrDialogFields.OPTIMIZE,
							OcrDialogFields.DESKEW,
							OcrDialogFields.DESPECKLE,
							OcrDialogFields.DITHERING,
							OcrDialogFields.NOISE_REDUCTION,
							OcrDialogFields.GAMMA_CORRECTION,
							OcrDialogFields.INCREASE_CONTRAST,
							OcrDialogFields.EDGE_ACCENTUATION,
							OcrDialogFields.SHARPEN,
							OcrDialogFields.MEDIAN_FILTER
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SIGNATURE,
				new FieldGroup([
					new PortalFields([
							SignatureDialogFields.FIELD,
							SignatureDialogFields.FIELD_NAME,
							SignatureDialogFields.CERTIFICATE,
							SignatureDialogFields.CERTIFICATE_PASSWORD,
							SignatureDialogFields.CERTIFICATE_MANUAL,
							SignatureDialogFields.REASON,
							SignatureDialogFields.LOCATION,
							SignatureDialogFields.CONTACT,
							SignatureDialogFields.LEVEL,
							SignatureDialogFields.PERSONAL_SIGNED_BY,
							SignatureDialogFields.PERSONAL_NAME,
							SignatureDialogFields.PERSONAL_EMAIL,
							SignatureDialogFields.ORGANISATION_COMMON_NAME,
							SignatureDialogFields.ORGANISATION_UNIT,
							SignatureDialogFields.ORGANISATION_NAME,
							SignatureDialogFields.ENVIRONMENT_LOCALE,
							SignatureDialogFields.ENVIRONMENT_STATE,
							SignatureDialogFields.ENVIRONMENT_COUNTRY,
							SignatureDialogFields.ENVIRONMENT_DATE,
							SignatureDialogFields.MODIFICATION_NAME,
							SignatureDialogFields.MODIFICATION_IDENTIFIER,
							SignatureDialogFields.APPEARANCE,
							SignatureDialogFields.COMMON_NAME,
							SignatureDialogFields.IDENTIFIER_PREFIX,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_FORMS,
				new FieldGroup([
					new PortalFields([
							FormsExtractionDialogFields.FORMAT
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.IMPORT_FORMS,
				new FieldGroup([
					new PortalFields([
							FormsImportDialogFields.FORMAT,
							FormsImportDialogFields.FILE,
							FormsImportDialogFields.FLATTEN
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EDIT_FORMS,
				new FieldGroup([
					new PortalFields([
							FormsImportDialogFields.FLATTEN
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SANITIZE,
				new FieldGroup([
					new PortalFields([
							SanitizeDialogFields.PAGERANGE,
							SanitizeDialogFields.ANNOTATIONS,
							SanitizeDialogFields.ATTACHMENTS,
							SanitizeDialogFields.FORMS,
							SanitizeDialogFields.LAYERS,
							SanitizeDialogFields.METADATA,
							SanitizeDialogFields.OUTLINES,
							SanitizeDialogFields.TAGS,
							SanitizeDialogFields.PAGES,
							SanitizeDialogFields.DPI,
							SanitizeDialogFields.ACTIONS
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.REDACT_AREA,
				new FieldGroup([
					new PortalFields([
							RedactDialogFields.CREATOR,
							RedactDialogFields.SUBJECT,
							RedactDialogFields.CONTENTS,
							RedactDialogFields.INTENTS,
							RedactDialogFields.BORDER,
							RedactDialogFields.FILL,
							RedactDialogFields.PAGE,
							RedactDialogFields.APPLY,
							RedactDialogFields.COLLISION,
							RedactDialogFields.ANNOTATIONS,
							RedactDialogFields.IMAGES,
							RedactDialogFields.PATHES,
							RedactDialogFields.TEXTS
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.REDACT_TEXT,
				new FieldGroup([
					new PortalFields([
							RedactDialogFields.CREATOR,
							RedactDialogFields.SUBJECT,
							RedactDialogFields.CONTENTS,
							RedactDialogFields.INTENTS,
							RedactDialogFields.BORDER,
							RedactDialogFields.FILL,
							RedactDialogFields.APPLY,
							RedactDialogFields.COLLISION,
							RedactDialogFields.ANNOTATIONS,
							RedactDialogFields.IMAGES,
							RedactDialogFields.PATHES,
							RedactDialogFields.TEXTS
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.REDACT_PAGE,
				new FieldGroup([
					new PortalFields([
							RedactDialogFields.CREATOR,
							RedactDialogFields.SUBJECT,
							RedactDialogFields.CONTENTS,
							RedactDialogFields.INTENTS,
							RedactDialogFields.BORDER,
							RedactDialogFields.FILL,
							RedactDialogFields.PAGE,
							RedactDialogFields.APPLY,
							RedactDialogFields.COLLISION,
							RedactDialogFields.ANNOTATIONS,
							RedactDialogFields.IMAGES,
							RedactDialogFields.PATHES,
							RedactDialogFields.TEXTS
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.REDACT,
				new FieldGroup([
					new PortalFields([
							RedactDialogFields.COLLISION,
							RedactDialogFields.ANNOTATIONS,
							RedactDialogFields.IMAGES,
							RedactDialogFields.PATHES,
							RedactDialogFields.TEXTS
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.REDACT_EDIT,
				new FieldGroup([
					new PortalFields([
							RedactDialogFields.CREATOR,
							RedactDialogFields.SUBJECT,
							RedactDialogFields.CONTENTS,
							RedactDialogFields.INTENTS,
							RedactDialogFields.BORDER,
							RedactDialogFields.FILL,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ADD_OUTLINE,
				new FieldGroup([
					new PortalFields([
							OutlineAddFields.NAME,
							OutlineAddFields.POSITION,
							OutlineAddFields.TARGET,
							OutlineAddFields.COLOR,
							OutlineAddFields.BOLD,
							OutlineAddFields.ITALIC,
							OutlineAddFields.OPEN,
							OutlineAddFields.ACTION,
							OutlineAddFields.ZOOM,
							OutlineAddFields.ACTION_JAVASCRIPT,
							OutlineAddFields.ACTION_URI,
							OutlineAddFields.EXECUTE_ACTION,
							OutlineAddFields.EXECUTE_CUSTOM,
							OutlineAddFields.GO_TO_PAGE,
							OutlineAddFields.GO_TO_TOP_OFFSET,
							OutlineAddFields.GO_TO_BOTTOM_OFFSET,
							OutlineAddFields.GO_TO_LEFT_OFFSET,
							OutlineAddFields.GO_TO_RIGHT_OFFSET,
							OutlineAddFields.GO_TO_ZOOM,
							OutlineAddFields.LIST
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE,
				new FieldGroup([
					new PortalFields([
							BarcodeFields.OUTPUT,
							BarcodeFields.CONTENT,
							BarcodeFields.FORMAT,
							BarcodeFields.MARGIN,
							BarcodeFields.ROTATION,
							BarcodeFields.WIDTH,
							BarcodeFields.HEIGHT,
							BarcodeFields.QRCODE_CORRECTION,
							BarcodeFields.AZTEC_CORRECTION,
							BarcodeFields.AZTEC_LAYER,
							BarcodeFields.DATAMATRIX_CORRECTION,
							BarcodeFields.DATAMATRIX_SHAPE,
							BarcodeFields.PDF417_CORRECTION,
							BarcodeFields.PDF417_COMPACTION,
							BarcodeFields.PDF417_DIMENSIONS,
							BarcodeFields.PDF417_COL_MIN,
							BarcodeFields.PDF417_COL_MAX,
							BarcodeFields.PDF417_ROW_MIN,
							BarcodeFields.PDF417_ROW_MAX,
							BarcodeFields.PREVIEW,
							BarcodeFields.PAGERANGE,
							BarcodeFields.SWISSQRCODE_CONTENT_FORMAT,
							BarcodeFields.SWISSQRCODE_DPI,
							BarcodeFields.SWISSQRCODE_LANGUAGE,
							BarcodeFields.SWISSQRCODE_SEPARATOR,
							BarcodeFields.SWISSQRCODE_FORMAT,
							BarcodeFields.FILENAME,
							BarcodeFields.UNIT
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE_AREA,
				new FieldGroup([
					new PortalFields([
							BarcodeFields.CONTENT,
							BarcodeFields.FORMAT,
							BarcodeFields.MARGIN,
							BarcodeFields.ROTATION,
							BarcodeFields.QRCODE_CORRECTION,
							BarcodeFields.AZTEC_CORRECTION,
							BarcodeFields.AZTEC_LAYER,
							BarcodeFields.DATAMATRIX_CORRECTION,
							BarcodeFields.DATAMATRIX_SHAPE,
							BarcodeFields.PDF417_CORRECTION,
							BarcodeFields.PDF417_COMPACTION,
							BarcodeFields.PDF417_DIMENSIONS,
							BarcodeFields.PDF417_COL_MIN,
							BarcodeFields.PDF417_COL_MAX,
							BarcodeFields.PDF417_ROW_MIN,
							BarcodeFields.PDF417_ROW_MAX,
							BarcodeFields.PREVIEW,
							BarcodeFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE_SWISS_QR,
				new FieldGroup([
					new PortalFields([
							BarcodeFields.CONTENT,
							BarcodeFields.PREVIEW,
							BarcodeFields.WIDTH,
							BarcodeFields.HEIGHT,
							BarcodeFields.PAGEMODE,
							BarcodeFields.PAGERANGE,
							BarcodeFields.SWISSQRCODE_CONTENT_FORMAT,
							BarcodeFields.SWISSQRCODE_DPI,
							BarcodeFields.SWISSQRCODE_LANGUAGE,
							BarcodeFields.SWISSQRCODE_SEPARATOR,
							BarcodeFields.SWISSQRCODE_FORMAT,
							BarcodeFields.SWISSQRCODE_POSITION
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_CREATE_SWISS_QR_AREA,
				new FieldGroup([
					new PortalFields([
							BarcodeFields.CONTENT,
							BarcodeFields.PREVIEW,
							BarcodeFields.WIDTH,
							BarcodeFields.HEIGHT,
							BarcodeFields.SWISSQRCODE_CONTENT_FORMAT,
							BarcodeFields.SWISSQRCODE_DPI,
							BarcodeFields.SWISSQRCODE_LANGUAGE,
							BarcodeFields.SWISSQRCODE_SEPARATOR
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_DETECT,
				new FieldGroup([
					new PortalFields([
							BarcodeDetectDialogFields.OUTPUT,
							BarcodeDetectDialogFields.FORMAT,
							BarcodeDetectDialogFields.CONTENT_LENGTH,
							BarcodeDetectDialogFields.PURE,
							BarcodeDetectDialogFields.GS1,
							BarcodeDetectDialogFields.CHECK_DIGIT,
							BarcodeDetectDialogFields.START_END_DIGITS,
							BarcodeDetectDialogFields.EXTENSION,
							BarcodeDetectDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_NOTE,
				new FieldGroup([
					new PortalFields([
							AnnotationNoteDialogFields.CREATOR,
							AnnotationNoteDialogFields.SUBJECT,
							AnnotationNoteDialogFields.CONTENTS,
							AnnotationNoteDialogFields.INTENTS,
							AnnotationNoteDialogFields.ICON,
							AnnotationNoteDialogFields.COLOR,
							AnnotationNoteDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_NOTE_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationNoteDialogFields.CREATOR,
							AnnotationNoteDialogFields.SUBJECT,
							AnnotationNoteDialogFields.CONTENTS,
							AnnotationNoteDialogFields.INTENTS,
							AnnotationNoteDialogFields.ICON,
							AnnotationNoteDialogFields.COLOR,
							AnnotationNoteDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_MARK,
				new FieldGroup([
					new PortalFields([
							AnnotationMarkDialogFields.CREATOR,
							AnnotationMarkDialogFields.SUBJECT,
							AnnotationMarkDialogFields.CONTENTS,
							AnnotationMarkDialogFields.INTENTS,
							AnnotationMarkDialogFields.COLOR,
							AnnotationMarkDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_MARK_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationMarkDialogFields.CREATOR,
							AnnotationMarkDialogFields.SUBJECT,
							AnnotationMarkDialogFields.CONTENTS,
							AnnotationMarkDialogFields.INTENTS,
							AnnotationMarkDialogFields.COLOR,
							AnnotationMarkDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_UNDERLINE,
				new FieldGroup([
					new PortalFields([
							AnnotationUnderlineDialogFields.CREATOR,
							AnnotationUnderlineDialogFields.SUBJECT,
							AnnotationUnderlineDialogFields.CONTENTS,
							AnnotationUnderlineDialogFields.INTENTS,
							AnnotationUnderlineDialogFields.COLOR,
							AnnotationUnderlineDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_UNDERLINE_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationUnderlineDialogFields.CREATOR,
							AnnotationUnderlineDialogFields.SUBJECT,
							AnnotationUnderlineDialogFields.CONTENTS,
							AnnotationUnderlineDialogFields.INTENTS,
							AnnotationUnderlineDialogFields.COLOR,
							AnnotationUnderlineDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STRIKE,
				new FieldGroup([
					new PortalFields([
							AnnotationStrikeDialogFields.CREATOR,
							AnnotationStrikeDialogFields.SUBJECT,
							AnnotationStrikeDialogFields.CONTENTS,
							AnnotationStrikeDialogFields.INTENTS,
							AnnotationStrikeDialogFields.COLOR,
							AnnotationStrikeDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STRIKE_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationStrikeDialogFields.CREATOR,
							AnnotationStrikeDialogFields.SUBJECT,
							AnnotationStrikeDialogFields.CONTENTS,
							AnnotationStrikeDialogFields.INTENTS,
							AnnotationStrikeDialogFields.COLOR,
							AnnotationStrikeDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUIGGLY,
				new FieldGroup([
					new PortalFields([
							AnnotationSquigglyDialogFields.CREATOR,
							AnnotationSquigglyDialogFields.SUBJECT,
							AnnotationSquigglyDialogFields.CONTENTS,
							AnnotationSquigglyDialogFields.INTENTS,
							AnnotationSquigglyDialogFields.COLOR,
							AnnotationSquigglyDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUIGGLY_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationSquigglyDialogFields.CREATOR,
							AnnotationSquigglyDialogFields.SUBJECT,
							AnnotationSquigglyDialogFields.CONTENTS,
							AnnotationSquigglyDialogFields.INTENTS,
							AnnotationSquigglyDialogFields.COLOR,
							AnnotationSquigglyDialogFields.OPACITY,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_LINE,
				new FieldGroup([
					new PortalFields([
							AnnotationLineFunctionFields.CREATOR,
							AnnotationLineFunctionFields.SUBJECT,
							AnnotationLineFunctionFields.CONTENTS,
							AnnotationLineFunctionFields.INTENTS,
							AnnotationLineFunctionFields.COLOR,
							AnnotationLineFunctionFields.OPACITY,
							AnnotationLineFunctionFields.STROKE,
							AnnotationLineFunctionFields.STYLE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_LINE_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationLineFunctionFields.CREATOR,
							AnnotationLineFunctionFields.SUBJECT,
							AnnotationLineFunctionFields.CONTENTS,
							AnnotationLineFunctionFields.INTENTS,
							AnnotationLineFunctionFields.COLOR,
							AnnotationLineFunctionFields.OPACITY,
							AnnotationLineFunctionFields.STROKE,
							AnnotationLineFunctionFields.STYLE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUARE,
				new FieldGroup([
					new PortalFields([
							AnnotationSquareFunctionFields.CREATOR,
							AnnotationSquareFunctionFields.SUBJECT,
							AnnotationSquareFunctionFields.CONTENTS,
							AnnotationSquareFunctionFields.INTENTS,
							AnnotationSquareFunctionFields.FILL,
							AnnotationSquareFunctionFields.OPACITY,
							AnnotationSquareFunctionFields.STROKE,
							AnnotationSquareFunctionFields.STYLE,
							AnnotationSquareFunctionFields.BORDER,
							AnnotationSquareFunctionFields.DRAW_MODE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_SQUARE_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationSquareFunctionFields.CREATOR,
							AnnotationSquareFunctionFields.SUBJECT,
							AnnotationSquareFunctionFields.CONTENTS,
							AnnotationSquareFunctionFields.INTENTS,
							AnnotationSquareFunctionFields.FILL,
							AnnotationSquareFunctionFields.OPACITY,
							AnnotationSquareFunctionFields.STROKE,
							AnnotationSquareFunctionFields.STYLE,
							AnnotationSquareFunctionFields.BORDER,
							AnnotationSquareFunctionFields.DRAW_MODE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_CIRCLE,
				new FieldGroup([
					new PortalFields([
							AnnotationCircleFunctionFields.CREATOR,
							AnnotationCircleFunctionFields.SUBJECT,
							AnnotationCircleFunctionFields.CONTENTS,
							AnnotationCircleFunctionFields.INTENTS,
							AnnotationCircleFunctionFields.FILL,
							AnnotationCircleFunctionFields.OPACITY,
							AnnotationCircleFunctionFields.STROKE,
							AnnotationCircleFunctionFields.STYLE,
							AnnotationCircleFunctionFields.BORDER,
							AnnotationCircleFunctionFields.DRAW_MODE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_CIRCLE_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationCircleFunctionFields.CREATOR,
							AnnotationCircleFunctionFields.SUBJECT,
							AnnotationCircleFunctionFields.CONTENTS,
							AnnotationCircleFunctionFields.INTENTS,
							AnnotationCircleFunctionFields.FILL,
							AnnotationCircleFunctionFields.OPACITY,
							AnnotationCircleFunctionFields.STROKE,
							AnnotationCircleFunctionFields.STYLE,
							AnnotationCircleFunctionFields.BORDER,
							AnnotationCircleFunctionFields.DRAW_MODE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.MERGE,
				new FieldGroup([
					new PortalFields([
							MergeDialogFields.FILES,
							MergeDialogFields.OPERATION,
							MergeDialogFields.PAGE,
							MergeDialogFields.RESET_METADATA,
							MergeDialogFields.PDFA_FORMAT,
							MergeDialogFields.PDFA_RESOLUTION,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.PORTFOLIO_CREATE,
				new FieldGroup([
					new PortalFields([
							PortfolioCreateDialogFields.FILENAME
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ENCRYPT,
				new FieldGroup([
					new PortalFields([
							EncryptDialogFields.OPEN_PASSWORD,
							EncryptDialogFields.PERMISSION_PASSWORD,
							EncryptDialogFields.PRINTING,
							EncryptDialogFields.CAN_MODIFY,
							EncryptDialogFields.CAN_ASSEMBLE,
							EncryptDialogFields.CAN_FILL_IN_FORM,
							EncryptDialogFields.CAN_MODIFY_ANNOTATIONS,
							EncryptDialogFields.CAN_EXTRACT_CONTENT,
							EncryptDialogFields.CAN_EXTRACT_FOR_ACCESSIBILITY,
							EncryptDialogFields.KEY,
							EncryptDialogFields.CONTENT_ENCRYPTION,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.CERTIFICATE_ENCRYPT,
				new FieldGroup([
					new PortalFields([
							CertificateEncryptDialogFields.KEY,
							CertificateEncryptDialogFields.CERTIFICATE,
							CertificateEncryptDialogFields.PRINTING,
							CertificateEncryptDialogFields.CAN_MODIFY,
							CertificateEncryptDialogFields.CAN_ASSEMBLE,
							CertificateEncryptDialogFields.CAN_FILL_IN_FORM,
							CertificateEncryptDialogFields.CAN_MODIFY_ANNOTATIONS,
							CertificateEncryptDialogFields.CAN_EXTRACT_CONTENT,
							CertificateEncryptDialogFields.CAN_EXTRACT_FOR_ACCESSIBILITY,
							CertificateEncryptDialogFields.ADD_RECEIPIENT,
							CertificateEncryptDialogFields.REMOVE_RECEIPIENT,
							CertificateEncryptDialogFields.CONTENT_ENCRYPTION,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.URLCONVERTER,
				new FieldGroup([
					new PortalFields([
							UrlConverterDialogFields.URL,
							UrlConverterDialogFields.USERNAME,
							UrlConverterDialogFields.PASSWORD,
							UrlConverterDialogFields.FORMAT,
							UrlConverterDialogFields.ORIENTATION,
							UrlConverterDialogFields.WIDTH,
							UrlConverterDialogFields.HEIGHT,
							UrlConverterDialogFields.MARGIN_LEFT,
							UrlConverterDialogFields.MARGIN_RIGHT,
							UrlConverterDialogFields.MARGIN_TOP,
							UrlConverterDialogFields.MARGIN_BOTTOM,
							UrlConverterDialogFields.PREVIEW,
							UrlConverterDialogFields.UNIT,
							UrlConverterDialogFields.HEADER_PLAIN,
							UrlConverterDialogFields.HEADER_FONT_FAMILY,
							UrlConverterDialogFields.HEADER_FONT_SIZE,
							UrlConverterDialogFields.HEADER_FONT_COLOR,
							UrlConverterDialogFields.HEADER_ALIGNMENT,
							UrlConverterDialogFields.HEADER_CONTENT,
							UrlConverterDialogFields.HEADER_MARGIN_LEFT,
							UrlConverterDialogFields.HEADER_MARGIN_RIGHT,
							UrlConverterDialogFields.HEADER_MARGIN_TOP,
							UrlConverterDialogFields.HEADER_MARGIN_BOTTOM,
							UrlConverterDialogFields.FOOTER_PLAIN,
							UrlConverterDialogFields.FOOTER_FONT_FAMILY,
							UrlConverterDialogFields.FOOTER_FONT_SIZE,
							UrlConverterDialogFields.FOOTER_FONT_COLOR,
							UrlConverterDialogFields.FOOTER_ALIGNMENT,
							UrlConverterDialogFields.FOOTER_CONTENT,
							UrlConverterDialogFields.FOOTER_MARGIN_LEFT,
							UrlConverterDialogFields.FOOTER_MARGIN_RIGHT,
							UrlConverterDialogFields.FOOTER_MARGIN_TOP,
							UrlConverterDialogFields.FOOTER_MARGIN_BOTTOM,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.BARCODE_SWISS_QR_CODE_FORM,
				new FieldGroup([
					new PortalFields([
							BarcodeSwissQrCodeFormDialogFields.VERSION,
							BarcodeSwissQrCodeFormDialogFields.CODING_TYPE,
							BarcodeSwissQrCodeFormDialogFields.ACCOUNT,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_NAME,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_TYPE,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_ADDRESSLINE1,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_ADDRESSLINE2,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_STREET,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_HOUSE_NUMBER,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_POSTAL_CODE,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_LOCATION,
							BarcodeSwissQrCodeFormDialogFields.CREDITOR_COUNTRY_CODE,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_NAME,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_TYPE,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_ADDRESSLINE1,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_ADDRESSLINE2,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_STREET,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_HOUSE_NUMBER,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_POSTAL_CODE,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_LOCATION,
							BarcodeSwissQrCodeFormDialogFields.DEBTOR_COUNTRY_CODE,
							BarcodeSwissQrCodeFormDialogFields.AMOUNT,
							BarcodeSwissQrCodeFormDialogFields.CURRENCY,
							BarcodeSwissQrCodeFormDialogFields.REFERENCE_TYPE,
							BarcodeSwissQrCodeFormDialogFields.REFERENCE,
							BarcodeSwissQrCodeFormDialogFields.UNSTRUCTURED_MESSAGE,
							BarcodeSwissQrCodeFormDialogFields.CONTENT,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.COMPRESS,
				new FieldGroup([
					new PortalFields([
							CompressionDialogFields.STREAM_SIZE,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SCALE,
				new FieldGroup([
					new PortalFields([
							ScaleDialogFields.FORMAT,
							ScaleDialogFields.WIDTH,
							ScaleDialogFields.HEIGHT,
							ScaleDialogFields.ORIENTATION,
							ScaleDialogFields.MARGIN_TOP,
							ScaleDialogFields.MARGIN_BOTTOM,
							ScaleDialogFields.MARGIN_LEFT,
							ScaleDialogFields.MARGIN_RIGHT,
							ScaleDialogFields.PREVIEW,
							ScaleDialogFields.ASPECT_RATIO,
							ScaleDialogFields.BOXES,
							ScaleDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.EXTRACT_HTML,
				new FieldGroup([
					new PortalFields([
							HtmlExtractionDialogFields.ERROR,
							HtmlExtractionDialogFields.DPI,
							HtmlExtractionDialogFields.PAGERANGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_DELETE,
				new FieldGroup([
					new PortalFields([
							DeleteAnnotationDialogFields.PAGE
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_REPLY,
				new FieldGroup([
					new PortalFields([
							AnnotationReplyDialogFields.CREATOR,
							AnnotationReplyDialogFields.CONTENTS,
							AnnotationReplyDialogFields.SUBJECT,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_REPLY_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationReplyDialogFields.CREATOR,
							AnnotationReplyDialogFields.CONTENTS,
							AnnotationReplyDialogFields.SUBJECT
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STAMP,
				new FieldGroup([
					new PortalFields([
							AnnotationStampFunctionFields.CREATOR,
							AnnotationStampFunctionFields.CONTENTS,
							AnnotationStampFunctionFields.SUBJECT,
							AnnotationStampFunctionFields.INTENTS,
							AnnotationStampFunctionFields.OPACITY,
							AnnotationStampFunctionFields.COLOR,
							AnnotationStampFunctionFields.BORDER_COLOR,
							AnnotationStampFunctionFields.FONT_COLOR,
							AnnotationStampFunctionFields.FONT_SIZE,
							AnnotationStampFunctionFields.TEXT,
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_STAMP_EDIT,
				new FieldGroup([
					new PortalFields([
							AnnotationCircleFunctionFields.CREATOR,
							AnnotationCircleFunctionFields.SUBJECT,
							AnnotationCircleFunctionFields.CONTENTS,
							AnnotationCircleFunctionFields.INTENTS,
							AnnotationCircleFunctionFields.FILL,
							AnnotationCircleFunctionFields.OPACITY
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.ANNOTATION_FLATTEN,
				new FieldGroup([
					new PortalFields([
							AnnotationFlattenDialogFields.PAGES
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
			[
				PortalDialogType.SIGNATURE_REMOVE,
				new FieldGroup([
					new PortalFields([
							SignatureRemoveDialogFields.FLATTEN
						],
						new MimeTypeFilter([], [MimeTypes.ALL])
					)
				])
			],
		]);
	}

	get fields(): Map<PortalDialogType, FieldGroup> {
		return this._fields;
	}

	public static get instance(): PortalDialogFields {
		return FunctionHelper.applyValue(
			this._instance, (this._instance = new this())
		);
	}
}

export default PortalDialogFields.instance;